import type { SkillInfo } from '../api/client'

export const PLATFORM_SKILLS_PATH = '/fleet-editor/platform-skills'

export function platformSkillPath(name?: string): string {
  return name === undefined
    ? PLATFORM_SKILLS_PATH
    : `${PLATFORM_SKILLS_PATH}/${encodeURIComponent(name)}`
}

export function platformSkillFromPath(pathname: string): string | undefined {
  if (!pathname.startsWith(`${PLATFORM_SKILLS_PATH}/`)) return undefined
  const encodedName = pathname.slice(PLATFORM_SKILLS_PATH.length + 1).replace(/\/$/, '')
  if (!encodedName || encodedName.includes('/')) return undefined
  try {
    return decodeURIComponent(encodedName)
  } catch {
    return undefined
  }
}

export function isInheritedFromPlatform(skill: Pick<SkillInfo, 'binding' | 'source'>): boolean {
  return skill.binding === 'all' && skill.source === 'core'
}

export function inheritedCount(skills: readonly Pick<SkillInfo, 'binding' | 'source'>[]): number {
  return skills.filter(skill => skill.binding === 'all').length
}

export function appliesToText(excludeRoles: readonly string[]): string {
  if (excludeRoles.length === 0) return 'Every agent'
  if (excludeRoles.length === 1) return `Every agent except the ${excludeRoles[0]}`
  return `Every agent except roles ${excludeRoles.join(', ')}`
}

export function agentCountText(composed: number, rosterSize: number, available: boolean): string {
  return available ? `${composed} of ${rosterSize}` : '—'
}
